import { documentId, FieldPath } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import Nav from "../components/navbar";
import PostsSection from "../components/post";
import { UserAuth } from "../context/authContext";
import {
  query,
  getDoc,
  collectionGroup,
  getDocs,
  orderBy,
  where,
  doc,
} from "firebase/firestore";
import { db } from "../firebase-config";
import moment from "moment";
import parse from "html-react-parser";

import Toptitle from "../components/pagetop";

const SinglePost = () => {
  const getId = () => {
    const currentURL = window.location.pathname;
    let formatURL = currentURL.replace("/post/", "");
    const arr = formatURL.split("=");
    arr.shift();
    formatURL = arr;

    return formatURL[0];
  };

  const getTitle = () => {
    const currentURL = window.location.pathname;
    let formatURL = currentURL.replace("/post/", "");

    let newFormat = formatURL.replace(`=${getId()}`, "");

    let final = newFormat.split("%20");
    newFormat = final.join(" ");

    return newFormat;
  };

  useEffect(() => {
    getId();
  }, []);

  const [posts, setPosts] = useState([]);
  const [loader, setLoader] = useState(true);
  const [users, setUsers] = useState([]);

  const getPost = async () => {
    const postsQuery = query(
      collectionGroup(db, "Posts"),
      where("postID", "==", getId()),
      where("title", "==", getTitle())
    );

    const querySnapshot = await getDocs(postsQuery);
    let tempPosts = [];

    const userparentPromises = [];
    querySnapshot.forEach((post) => {
      const postRef = post.ref;
      const postRefParent = postRef.parent;
      const postRefParent_ParentDoc = postRefParent.parent;
      const postCategoriesColRef = postRefParent_ParentDoc.parent;
      const postCategoriesColRef_userDocRef = postCategoriesColRef.parent;

      userparentPromises.push(getDoc(postCategoriesColRef_userDocRef));

      tempPosts.push({ id: post.id, data: post.data() });
    });
    setPosts(tempPosts);

    const arrayofParentUserDoc = await Promise.all(userparentPromises);
    setUsers(arrayofParentUserDoc);

    setLoader(false);
  };

  useEffect(() => {
    getPost();
  }, []);

  return (
    <div className="mainWrapper">
      <Nav />
      <div className="innerwrapper overflow-y-auto p-0">
        <Toptitle title="Post" />
        <div className="mt-2 h-full px-7 w-full">
          {loader === false &&
            posts.map((post, index) => (
              <PostsSection
                key={index}
                publishedBy={users[index].data().username}
                datePublished={
                  post.data.datePublished &&
                  moment(post.data.datePublished.toDate()).calendar()
                }
                profilePic={users[index].data().profilePic}
                title={post.data.title}
                content={post.data.content && parse(post.data.content)}
                tumbnailURL={post.data.tumbnailURL && post.data.tumbnailURL}
                pdfName={post.data.pdfName && post.data.pdfName}
                pdfURL={post.data.pdfURL && post.data.pdfURL}
                instaURL={users[index].data().instaURL}
                twitterURL={users[index].data().twitterURL}
                linkedinURL={users[index].data().linkedin}
                githubURL={users[index].data().githubURL}
                about={users[index].data().bio}
                occupation={users[index].data().occupation}
                postId={post.id}
                publishedId={post.data.publishedBy}
                caption={post.data.caption}
                postCategory={post.data.category}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default SinglePost;
